/** @format */

import config from "../../config/index.json";

export function getUrl() {
  return config.share[import.meta.env.MODE] + this.state.uid;
}
